<script>
import appConfig from '../../../../../shared/helpers/appConfig';
export default {
  name: "InfoModal",
  props: {
    shareEmail: {
      type: String,
      default: appConfig('VUE_APP_GOOGLE_SHEET_EMAIL')
    }
  },
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async copyEmail() {
      try {
        await navigator.clipboard.writeText(this.shareEmail);
        this.copied = true;
        setTimeout(() => (this.copied = false), 2000);
      } catch (e) {
        console.error("Failed to copy:", e);
      }
    }
  }
};
</script>

<template>
  <div class="fixed inset-0 flex items-center justify-center bg-slate-800/80 dark:bg-slate-900/80 z-50">
    <div class="bg-white dark:bg-slate-800 rounded-lg p-6 shadow-lg w-[600px] max-h-[90vh] overflow-y-auto border border-slate-200 dark:border-slate-700">
      <!-- Header -->
      <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold text-slate-800 dark:text-slate-100">
          Toggle Row
        </h1>
        <woot-button
          variant="clear"
          color-scheme="secondary"
          icon="dismiss"
          class="hover:bg-slate-100 dark:hover:bg-slate-700 rounded-full"
          @click="close"
        />
      </div>

      <!-- Description -->
      <p class="text-sm text-slate-600 dark:text-slate-300 mb-6">
        Use the toggle switch to control which data rows the bot will consider when replying to customers. 
        Disabled rows will be ignored by the bot, while enabled rows will be included in its responses.
      </p>

      <!-- Action -->
      <div class="flex justify-end mt-6">
        <woot-button
          color-scheme="secondary"
          class="hover:bg-slate-100 dark:hover:bg-slate-700"
          @click="close"
        >
          Close
        </woot-button>
      </div>
    </div>
  </div>
</template>



